import { normalizeBlogData } from './blog';
import { normalizeCityData } from './city';
import { normalizeCountryData } from './country';

export default function (data: {}, pageName: string) {
  switch (pageName) {
    case 'Blog':
      return normalizeBlogData(data);
    case 'Cities':
      return normalizeCityData(data);
    case 'CountryGuide':
      return normalizeCountryData(data);
    default:
      return data;
  }
}
